document.addEventListener('DOMContentLoaded', function() {
    
    let collectionProducts = document.querySelector('.collection-products');
    let buttonShowFilters = document.querySelector('.button-show-filters');
    let facetForm = document.querySelector('.collection-filters form');
    let facetFormInputs = document.querySelectorAll('.collection-filters input');
    let facetFilters = document.querySelector('.collection-filters');
    let facetProducts = document.querySelector('.collection-products');
    let facetButtonApply = document.querySelector('.button-filter-apply');
    let facetSort = document.querySelector('#collection-sort');
    let section = document.querySelector('.shopify-section-collection').id.replace('shopify-section-', '');
    let prevSearchParams = false;
    let hasFilterOpen = false;
    const headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-offset')) || 0;

    // Button Show filters
    buttonShowFilters.addEventListener('click', (event) => {
      if ( hasFilterOpen ) {
        hasFilterOpen = false;
      } else {
        hasFilterOpen = true;
      }
    });

    // Filter Mask
    

    // Sorting
    facetSort.addEventListener('change',  (event) => {
      applyFilters(false);
    });

    // Hide the apply Button as it's Ajaxified
    facetButtonApply.classList.add('is-hidden');
    facetButtonApply.addEventListener('click',  (event) => {
      event.preventDefault();
    });
  
    // Bind for changes on the filters
    facetFormInputs.forEach((input, i) => {
        input.addEventListener('change',  (event) => {
          applyFilters(false);
        });
    });

    // Bind for history changes
    window.addEventListener('popstate', function(event) {
      if ( event.state.searchParams != prevSearchParams ) {
        applyFilters(event.state.searchParams);
      }
    });

    // // Bind for filters
    // function filterChange() {
    //   document.querySelector('.collection-filters').addEventListener('change', (event) => {
    //       // Make sure, that you're receiving event from a correct element
    //       if (event.target.nodeName === 'INPUT') {
    //           event.preventDefault();
    //           // applyFilters(link.href.replace(window.location.pathname + '?', ''));
    //           applyFilters();
    //         }
    //   });
    // }
    // filterChange();

    // Delegated filter handler that works when .collection-filters is replaced via AJAX
    document.addEventListener('change', (event) => {
        // bail out if not coming from an INPUT inside .collection-filters
        const tgt = event.target;
        if (!tgt || tgt.nodeName !== 'INPUT') return;
        if (!tgt.closest('.collection-filters')) return;

        event.preventDefault();
        applyFilters();
    });

    // Bind for active filters
    function activeFilters() {
        if (document._activeFiltersBound) return;
        document._activeFiltersBound = true;
        console.log('bind activeFilters (delegated)');

        document.addEventListener('click', (event) => {
            const link = event.target.closest('.collection-filters-active a, .pagination a');
            if (!link) return;

            event.preventDefault();
            applyFilters(link.href.replace(window.origin + window.location.pathname + '?', ''));
        });
    }
    activeFilters();

    // Bind for pagination
    function bindPagination() {
        if (document._paginationBound) return;
        document._paginationBound = true;
        console.log('bind pagination (delegated)');

        document.addEventListener('click', (event) => {
            const link = event.target.closest('.pagination a');
            if (!link) return;

            event.preventDefault();
            applyFilters(link.href.replace(window.origin + window.location.pathname + '?', ''), true);
        });
    }
    bindPagination();

  
    function applyFilters(searchParams = false, scrollTop = false) {

        if (searchParams === false) {
          
          searchParams = createSearchParams(facetForm);
  
          // Set Sort
          if ( facetSort.value ) {
            searchParams.set('sort_by', facetSort.value );
          }
  
          searchParams = searchParams.toString();
        }
      
        // Build URL
        let url = window.location.pathname + '?' + searchParams;

        // Add Loading class
        facetProducts.classList.add('is-loading');

        // Update History state
        history.pushState({ searchParams }, '', url);
        prevSearchParams = searchParams;
  
        // Render
        renderSectionFromFetch(url);

        // Scroll top top
        if ( scrollTop ) {
          const top = document.querySelector('.collection-listing').getBoundingClientRect().top + window.pageYOffset - headerOffset;
          window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: 'smooth' });
        }
    } 

    function createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData);
    }

  
    function renderSectionFromFetch(url) {

        // Add 'section' parameter to AJAX a fragment
        // Set Section ID
        url = url + '&section_id=' + section;
      
        console.log('renderSectionFromFetch');

        // Update
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;

            // Render Content
            renderCollectionProducts(html);
            renderCollectionFilters(html);
            renderCollectionSorting(html);
            renderActiveFilters(html);
            renderPagination(html);
            
            // Lazyload update
            lazyLoadInstance.update();
            console.log('fetch');

            // Remove loading class
            facetProducts.classList.remove('is-loading');
        });
    }

    function renderCollectionSorting(html) {
      facetSort.value = new DOMParser().parseFromString(html, 'text/html').querySelector('#collection-sort').value;
    }
  
    function renderProductGridContainer(html) {
      facetProducts.innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.collection-products').innerHTML;
    }
  
    function renderCollectionProducts(html) {
      document.querySelector('.collection-products').innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.collection-products').innerHTML;
    }

    function renderPagination(html) {
      let pagination = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.pagination');
      
      if ( pagination ) {
        document.querySelector('.pagination').innerHTML = pagination.innerHTML; 
      } else {
        document.querySelector('.pagination').innerHTML = '';
      }
    }

    function renderActiveFilters(html) {
      document.querySelector('.collection-filters-active').innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.collection-filters-active').innerHTML; 
    }
    
    function renderCollectionFilters(html) {
      filterHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.collection-filters');

      // Merge Changes
      Idiomorph.morph(facetFilters, filterHTML, {
        callbacks:{
          afterNodeAdded:function(node){
            if ( isElement(node) ) { 
              if ( node.classList.contains('collection-filter')) {
                // Rebind events 
                // filterChange();
              }
            }
          }
        }
      });
    }

    function isElement(element) {
      return element instanceof Element || element instanceof HTMLDocument;  
    }
});